<template>
    <div class="nPanel">
        <!-- 顶部组件 -->
        <n-SearchLsit ref="SearchLsit" :list="config.searchList" :loading="loading" @onSearchChange="onSearchChange" @cascadeChange="cascadeChange">
            <div slot="table-module-btn-left">
                <slot name="table-module-btn-left"></slot>
            </div>
            <div slot="table-module-btn" class="btn-box">
                <slot name="table-module-btn"></slot>
            </div>
        </n-SearchLsit>
        <!-- table 组件 -->
        <n-table @rowDBclick="rowDBclick" :tableList="config.table" @onSelectionChange="onSelectionChange" :tableData="tableData" @btn-event="btnEvent" @switch-change="switchChange"
            @handleDetail="handleDetail" @handleCurrentChange="handleCurrentChange"></n-table>
        <!-- 分页组件 -->
        <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="12" class="page-text">
                <div v-if="config.table.selectBtn">
                    {{$translate('lang.E3202102230003', { defaultText: '已选' })}}
                    <span class="text-color">&nbsp;&nbsp;{{checkedNum}}&nbsp;&nbsp;</span>
                    {{$translate('lang.E3202101270008', { defaultText: '项' })}}
                </div>
                <slot name="page-module-btn"></slot>
            </el-col>
            <el-col :span="12">
                <n-page ref="page" id="paging" v-if="config.showPage" :currentPage="currentPage" :pageData="config.page" :total="pageTotal" @on-page-change="pageChange" @on-size-change="sizeChange">
                </n-page>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import nSearchLsit from './nSearchLsit.vue';
import nTable from './nTable.vue';
import nPage from './mPage/Main';
export default {
    components: { nSearchLsit, nTable, nPage },
    props: {
        config: {
            type: Object,
            default() {
                return {};
            }
        },
        pageTotal: {
            type: Number,
            default() {
                return 0;
            }
        },
        tableData: {
            type: Array,
            default() {
                return [];
            }
        },
        currentPage: {
            type: Number,
            default() {
                return 1;
            }
        }
    },
    data() {
        return {
            loading: false,
            checkedNum: 0
        };
    },
    mounted() {
        // console.log(this.config);
    },
    methods: {
        cascadeChange(val, configuration) {
            this.$emit('cascadeChange', val, configuration);
        },
        onSearchChange(data) {
            this.$refs.page.pageState = false;
            this.$emit('onSearchChange', data);
            this.$nextTick(() => {
                this.$refs.page.pageState = true;
            });
        },
        pageChange(pageNo) {
            this.$emit('pageChange', pageNo);
        },
        sizeChange(pageSize) {
            this.$emit('sizeChange', pageSize);
        },
        onSelectionChange(data) {
            this.checkedNum = data.length;
            this.$emit('onSelectionChange', data);
        },
        // 操作
        btnEvent(selection, event) {
            this.$emit('btn-event', selection, event);
        },
        // 启用停用
        switchChange(data) {
            this.$emit('switch-change', data);
        },
        rowDBclick(data) {
            this.$emit('rowDBclick', data);
        },
        handleDetail(data) {
            this.$emit('handleDetail', data);
        },
        handleCurrentChange(data) {
            this.$emit('handleCurrentChange', data);
        }
    }
};
</script>
<style lang="less">
.nPanel {
    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .margin-bottom-10 {
        margin-bottom: 10px;
    }
    .m-table-wrapper {
        border: 0;
    }

    .m-table:after {
        width: 0;
    }

    .m-table:before {
        height: 0;
    }

    .m-table td,
    .m-table th {
        border-bottom: 0;
    }

    .zk-table {
        border: 0;
    }

    .zk-table__body,
    .zk-table__footer,
    .zk-table__header {
        border-collapse: initial;
    }
    .page-text {
        display: flex;
        > div {
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            margin-right: 10px;
            .text-color {
                color: #4285f5;
            }
        }
    }

    .btn-box {
        display: flex;
        justify-content: flex-end;
    }
    .row-bg {
        margin-top: 20px;
    }
    .allocation-box {
        margin-left: 10px;
    }
    .el-table {
        height: calc(~"100vh - 180px") !important;
    }
    .column-config-title small {
        margin-left: 25px;
    }
    .el-table--border {
        border: 1px solid #ebeef5;
    }
}
</style>
